<template>
  <div class="content bg8">
    <div class="middled">
      <div class="basehero">
        <h1>
          The Foclarity Solution
        </h1>
        <h2 class="section">
          Boost Productivity through Focus, Clarity, and Alignment
        </h2>
        <p>
          Underperformance: This term refers to a team's inability to meet the expected standards or goals for their work. It can manifest in various ways, such as consistently missing deadlines, producing low-quality work, or failing to achieve desired results.
        </p>
        <p>
          The Foclarity Solution is a modern SaaS platform designed to help startups and small teams achieve focus, clarity, and alignment. Our solution brings together powerful tools, proven frameworks, and AI-driven workspaces to streamline your operations, boost productivity, and accelerate growth.
        </p>
        <ul class="bullets">
            <li><strong>Strategic Planning Tools:</strong> Set goals, track progress, and align your team with company vision using built-in frameworks.</li>
            <li><strong>Collaboration & Communication:</strong> Real-time updates, shared dashboards, and integrated messaging for seamless teamwork.</li>
            <li><strong>Performance Analytics:</strong> Visualize key metrics and make data-driven decisions with actionable reports.</li>
            <li><strong>Customizable Workflows:</strong> Adapt the solution to your unique processes and scale as your team grows.</li>
            <li><strong>Centralized Team Workspace:</strong> Manage projects, tasks, and communications in one place.</li>
            <li><strong>AI-Enhanced Productivity:</strong> Smart suggestions, automated reminders, and intelligent insights to keep your team on track.</li>
        </ul>
        <div class="panel max fullbluelt">
          <div class="row middled">
            <div class="column" style="justify-content:center;margin:auto;">
              <div style="padding:0px 20px;">
                <div class="marketline">
                  Why Teams Love Foclarity
                </div>
                <h3 style="line-height:1.5em;">
                  &ldquo;Foclarity gave our startup the structure and clarity we needed to move fast and stay aligned. The solution's AI features save us hours every week, and the team is always improving the product!&rdquo;
                </h3>
                <p>
                  Startup Founder<br>
                  Early Adopter
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="button-row">
          <a href="https://calendly.com/foclarity/30min" target="_blank" rel="nofollow">
            <button class="wide" style="background: #004466; color: #fff;">Request a Demo</button>
          </a>
          <router-link to="/pricing">
            <button class="wide" style="background: #BF00FF; color: #fff;">Get Started Free</button>
          </router-link>
        </div>
        <div class="centered">
            <h3>Need help finding and hiring the right team?</h3>
            <p>Check out our <a href="/who-we-serve" class="pink">Managed Internship Programs</a>.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: 'Team Productivity Solution | Foclarity',
  name: "Solution",
};
</script>

<style lang="scss" scoped>
.bullets {
  margin: 20px 0;
  padding-left: 20px;
}
.button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 32px 0 0 0;
}
.panel.max.fullbluelt {
  background: #f6f6ff;
  border-radius: 8px;
  margin: 40px 0;
  padding: 32px 0;
}
.marketline {
  color: #BF00FF;
  font-weight: bold;
  margin-bottom: 12px;
  font-size: 18px;
}
</style>
